import styled from 'styled-components';
import {space, SpaceProps, layout, LayoutProps, border, BorderProps } from 'styled-system';

const Box = styled.div<SpaceProps & LayoutProps & BorderProps >`
    ${space};
    ${layout};
    ${border}
`

export default Box